import api from './client';

export const getRooms = (projectId) => api.get('/rooms', { params: { project: projectId } });
export const createRoom = (data) => api.post('/rooms', data);
export const updateRoom = (id, data) => api.put(`/rooms/${id}`, data);
export const deleteRoom = (id) => api.delete(`/rooms/${id}`);
